import { createContext } from 'react';

const TransformContext = createContext({});
const LocalizationContext = createContext({});

export { TransformContext, LocalizationContext };
